import * as React from 'react';
import {
  ShowBase,
  useRecordContext,
  useRedirect,
} from 'react-admin';
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';

import VideoField from './VideoField';

const useStyles = makeStyles({
  dialog: {
    position: 'absolute',
    top: 50,
  }
});

export const PublicationShow = ({ open, id }) => {
  const redirect = useRedirect();
  const classes = useStyles();
  const { pathname } = useLocation();

  const handleClose = () => {
    redirect(pathname.replace(`/${id}`, ''));
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      classes={{ paper: classes.dialog }}
    >
      <DialogContent>
        <ShowBase resource="publications" basePath="/publications" id={id}>
          <PublicationShowContent />
        </ShowBase>
      </DialogContent>
    </Dialog>
  );
}

const PublicationShowContent = () => {
  const record = useRecordContext();
  
  if (!record) return null;

  return (
    <>
      <Box style={{ whiteSpace: 'pre-line' }}>
        <Box display="flex" justifyContent="center" mb={2}>
          <VideoField />
        </Box>
        <Typography color="textSecondary" vairant="body2">
          Description
        </Typography>
        <Typography>{record.description}</Typography>
      </Box>
    </>
  );
}